    // storage-gb.pipe.ts
    import { Pipe, PipeTransform } from '@angular/core';

    @Pipe({
      name: 'storageMb'
    })
    export class StorageMbPipe implements PipeTransform {
      transform(bytes: number): string {
        if (bytes === null || bytes === undefined) {
          return '';
        }
        const megabytes = bytes / (1024 * 1024);
        return `${megabytes.toFixed(3)} MB`; // Formats to 3 decimal places
      }
    }